// extracted by mini-css-extract-plugin
export default {"avatarLink":"userProfileBar_avatarLink__Z6lU1","avatarLogo":"userProfileBar_avatarLogo__tZcqh","avatarHolder":"userProfileBar_avatarHolder__jOqOk"};